import { SectionRowViewModel } from './SectionRowViewModel';

export class SectionRowViewModelOrderReviewReport extends SectionRowViewModel {}
